/**
 * Returns the correct library/dashboard path based on authentication state.
 * Use this instead of hardcoding '/dashboard' in navigation and links.
 * @param {Object|null} user - The current user object (null for guests)
 * @returns {string} '/dashboard' for authenticated users, '/library' for guests
 */
export const getLibraryPath = (user) => user?.uid ? '/dashboard' : '/library';
